import BaseListPresenter from "../../base/BaseListPresenter";
import { getCurrentUserUseCase } from "../../usecases/user";
import {
  format,
  startOfDay,
  addHours,
  addMinutes,
  addDays,
  parseISO,
} from "date-fns";
import xhr from "../../usecases/xhr/Xhr";

class SaleTransPresenter extends BaseListPresenter {
  init() {
    this.limit = 50000;
    this.where = {};
    this.search = {};
    this.filter = {};
    this.filterDate = {};
    this.filterDate2 = {};
    this.filterStore = {};
    this.filterStore2 = {};
    this.include = ["all"];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.reset();
  }

  componentDidMount() {
    this.init();
    this.findStore();
    this.getObjects2();
    return this.getObjects();
  }

  componentWillUnmount() {
    this.cleanup();
  }

  async getObjects() {
    this.reset();
    this.find();
    // this.find2();
  }

  async getObjects2() {
    this.reset();
    this.find2();
  }

  async findStore() {
    const user = await getCurrentUserUseCase().execute();
    const storeQuery = { include: ["all"], where: { email: user.email } };
    this.findObjectUseCase.abort();
    this.store = await this.findObjectUseCase.execute("users", storeQuery);

    const store = (this.store?.[0]?.storeAnalytic ?? []).sort((a, b) =>
      a.name.toUpperCase().localeCompare(b.name.toUpperCase()),
    );
    this.view.setStore(store);
  }

  async find() {
    try {
      if (this.abortController && !this.abortController.signal.aborted) {
        this.abortController.abort();
        console.log("Aborted previous requests");
        await new Promise((resolve) => setTimeout(resolve, 100));
      }

      this.abortController = new AbortController();
      this.objects = [];
      const startTime = Date.now();

      const query = this.createQuery({ skip: 0, limit: this.limit });

      delete query.limit;
      delete query.include;

      const startDate = query.where?.tran_date?.$gte || "";
      const endDate = query.where?.tran_date?.$lte || "";

      const dateRanges = this.generateDateRanges(startDate, endDate);

      for (let i = 0; i < dateRanges.length; i++) {
        const range = dateRanges[i];

        const chunkQuery = {
          ...query,
          where: {
            ...query.where,
            tran_date: {
              $gte: range.start,
              $lte: range.end,
            },
          },
        };

        console.log("chunkQuery", chunkQuery);

        try {
          const chunkData = await xhr.get("/transactions", {
            params: chunkQuery,
            signal: this.abortController.signal,
          });

          this.objects = this.objects.concat(chunkData);
          this.view.setObjects(this.objects);
        } catch (chunkError) {
          if (chunkError.name === "AbortError") {
            console.log("Request was aborted at chunk", i + 1);
            return;
          }
          console.error(`Error fetching ${range.label}:`, chunkError.message);
        }
      }

      const downloadTime = ((Date.now() - startTime) / 1000).toFixed(1);
      console.log(
        `✅ Complete! ${this.objects.length.toLocaleString()} records in ${downloadTime}s`,
      );
      this.abortController = null;
    } catch (error) {
      if (error.name === "AbortError") {
        console.log("Entire operation was aborted");
        return;
      }
      console.error("Error:", error.message);
    }
  }

  async find2() {
    try {
      // if (this.abortController && !this.abortController.signal.aborted) {
      //   this.abortController.abort();
      //   console.log("Aborted previous requests");
      //   await new Promise((resolve) => setTimeout(resolve, 100));
      // }

      // this.abortController = new AbortController();
      this.objects2 = [];
      const startTime = Date.now();

      const query = this.createQuery2({ skip: 0, limit: this.limit });

      console.log("qqq", query);

      delete query.limit;
      delete query.include;

      const startDate = query.where?.tran_date?.$gte || "";
      const endDate = query.where?.tran_date?.$lte || "";

      const dateRanges = this.generateDateRanges(startDate, endDate);

      for (let i = 0; i < dateRanges.length; i++) {
        const range = dateRanges[i];

        const chunkQuery = {
          ...query,
          where: {
            ...query.where,
            tran_date: {
              $gte: range.start,
              $lte: range.end,
            },
          },
        };

        console.log("chunkQuery", chunkQuery);

        try {
          const chunkData = await xhr.get("/transactions", {
            params: chunkQuery,
            // signal: this.abortController.signal,
          });

          this.objects2 = this.objects2.concat(chunkData);
          this.view.setObjects2(this.objects2);
        } catch (chunkError) {
          if (chunkError.name === "AbortError") {
            console.log("Request was aborted at chunk", i + 1);
            return;
          }
          console.error(`Error fetching ${range.label}:`, chunkError.message);
        }
      }

      const downloadTime = ((Date.now() - startTime) / 1000).toFixed(1);
      console.log(
        `✅ Complete! ${this.objects.length.toLocaleString()} records in ${downloadTime}s`,
      );
      // this.abortController = null;
    } catch (error) {
      if (error.name === "AbortError") {
        console.log("Entire operation was aborted");
        return;
      }
      console.error("Error:", error.message);
    }
  }

  cleanup() {
    if (this.abortController) {
      console.log("🧹 Cleaning up...");
      this.abortController.abort();
      this.abortController = null;
    }
    this.objects = [];
  }

  // Simple range generator: ≤31 days = 1 request, >31 days = monthly chunks
  generateDateRanges(startDateStr, endDateStr) {
    const start = new Date(startDateStr.split(" ")[0]);
    const end = new Date(endDateStr.split(" ")[0]);

    const daysDiff = Math.ceil((end - start) / (1000 * 60 * 60 * 24));

    console.log(`📆 Date range: ${daysDiff} days`);

    // If 31 days or less, single request
    if (daysDiff <= 31) {
      console.log("Strategy: Single request (≤31 days)");
      return [
        {
          start: this.formatDate(start),
          end: this.formatDate(end),
          label: `${start.toLocaleDateString()} - ${end.toLocaleDateString()}`,
        },
      ];
    }

    // More than 31 days, use monthly chunks
    console.log("Strategy: Monthly chunks (>31 days)");
    return this.generateMonthlyRanges(start, end);
  }

  // Generate monthly ranges
  generateMonthlyRanges(startDate, endDate) {
    const ranges = [];
    let current = new Date(startDate);

    while (current < endDate) {
      const monthStart = new Date(current);
      const monthEnd = new Date(
        current.getFullYear(),
        current.getMonth() + 1,
        0,
        23,
        59,
        59,
      );

      if (monthEnd > endDate) {
        monthEnd.setTime(endDate.getTime());
      }

      ranges.push({
        start: this.formatDate(monthStart),
        end: this.formatDate(monthEnd),
        label: monthStart.toLocaleString("default", {
          month: "short",
          year: "numeric",
        }),
      });

      current.setMonth(current.getMonth() + 1);
    }

    return ranges;
  }

  // Format date for API
  formatDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day} 05:00:00.000`;
  }

  reset2() {
    this.objects2 = [];
    this.count = 0;
    this.current = 1;
    this.view.setObjects2([]);
    this.view.setSelected([]);
    this.view.setCount(0);
    this.view.setTotal(0);
  }

  // async getObjects2() {
  //   // this.reset2();
  //   await this.findObjects2();
  // }

  createQuery2({ skip = 0, limit = this.limit } = {}) {
    const storeCodes =
      this.store?.flatMap((s) => s.storeAnalytic?.map((a) => a?.name)) ?? [];

    const escapedSearch = this.searchAny
      ?.trim()
      ?.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

    const whereClause = {
      ...(this.where || {}),
      ...(this.filter || {}),
      ...(this.filterDate2 || {}),
    };

    if (this.filterStore2 === "AllStore") {
      if (storeCodes.length > 0) {
        whereClause.store_code = { $in: storeCodes };
      }
    } else if (this.filterStore2) {
      whereClause.store_code = this.filterStore2;
    }

    // 3) Build final query
    const query = {
      limit,
      skip,
      where: whereClause,
      include: this.include,
      keys: this.keys ?? [
        "store_code",
        "tran_date",
        "tran_id",
        "total",
        "total_taxfree",
        "total_tax",
        "discount_amount",
        "createdAt",
        "cust_name",
        "tran_type",
        "paymenttype",
        "cust_count",
        "status",
        "shareArray",
        "paymenttypetotal",
        "paymenttype2",
        "paymenttype2total",
        "paymenttype3",
        "paymenttype3total",
        "reopen",
        "reopen_user_id",
        "total_pretax",
        "items",
      ],
      sort: this.sort,
    };

    return query;
  }

  createQuery({ skip = 0, limit = this.limit } = {}) {
    const storeCodes =
      this.store?.flatMap((s) => s.storeAnalytic?.map((a) => a?.name)) ?? [];

    const escapedSearch = this.searchAny
      ?.trim()
      ?.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

    const whereClause = {
      ...(this.where || {}),
      ...(this.filter || {}),
      ...(this.filterDate || {}),
    };

    if (this.filterStore === "AllStore") {
      if (storeCodes.length > 0) {
        whereClause.store_code = { $in: storeCodes };
      }
    } else if (this.filterStore) {
      whereClause.store_code = this.filterStore;
    }

    // 3) Build final query
    const query = {
      limit,
      skip,
      where: whereClause,
      include: this.include,
      keys: this.keys ?? [
        "store_code",
        "tran_date",
        "tran_id",
        "total",
        "total_taxfree",
        "total_tax",
        "discount_amount",
        "createdAt",
        "cust_name",
        "tran_type",
        "paymenttype",
        "cust_count",
        "status",
        "shareArray",
        "paymenttypetotal",
        "paymenttype2",
        "paymenttype2total",
        "paymenttype3",
        "paymenttype3total",
        "reopen",
        "reopen_user_id",
        "total_pretax",
        "items",
      ],
      sort: this.sort,
    };

    return query;
  }

  // createQuery() {
  //   const skip = (this.current - 1) * this.limit;
  //   const query = {
  //     limit: this.limit,
  //     skip: skip,
  //     where: {
  //       ...this.where,
  //       ...this.search,
  //       ...this.filter,
  //       ...this.filterDate,
  //     },
  //     include: this.include,
  //     keys: [
  //       "store_code",
  //       "status",
  //       "tran_date",
  //       "total",
  //       "total_tax",
  //       "createdAt",
  //       "discount_amount",
  //       "shareArray",
  //       "paymenttypetotal",
  //       "paymenttype2",
  //       "paymenttype2total",
  //       "paymenttype3",
  //       "paymenttype3total",
  //       "reopen",
  //       "reopen_user_id",
  //     ],
  //   };
  //   if (this.sort) {
  //     query.sort = this.sort;
  //   }
  //   const keys = this.keys || this.view.getKeys() || [];
  //   if (keys.length > 0) {
  //     query.keys = keys;
  //   }
  //   return query;
  // }

  async findObjects() {
    this.showProgress();
    try {
      // 1) Load user + store (kailangan bago gumawa ng whereClause)
      const user = await getCurrentUserUseCase().execute();
      const storeQuery = { include: ["all"], where: { email: user.email } };
      this.store = await this.findObjectUseCase.execute("users", storeQuery);

      const store = (this.store?.[0]?.storeAnalytic ?? []).sort((a, b) =>
        a.name.toUpperCase().localeCompare(b.name.toUpperCase()),
      );
      this.view.setStore(store);

      // 2) Build base filters (AllStore -> $in ng lahat ng analytic names)
      const storeCodes =
        this.store?.[0]?.storeAnalytic?.map((a) => a?.name).filter(Boolean) ??
        [];

      if (Object.keys(this.filterDate ?? {}).length === 0) {
        // kailangan merong date filter para hindi mag-load ng sobrang laki
        console.log("No date filter; aborting fetch for safety.");
        return;
      }

      const where = {
        store_code:
          this.filterStore === "AllStore"
            ? { $in: storeCodes }
            : this.filterStore,
        ...this.filterDate,
      };

      // 3) Count muna gamit ang full filter
      this.findObjectUseCase.abort(); // cancel any in-flight
      const { count } = await this.countObjectUseCase.execute(
        this.view.getCollectionName(),
        { where },
      );
      this.count = count ?? 0;
      this.view.setCount(this.count);

      // Reset UI state
      this.objects = [];
      this.view.setObjects([]);
      this.view.setTotal(0);
      this.view.setNotFound(false);

      // Not-found delay (optional)
      let timeoutId = null;
      if (this.count === 0) {
        timeoutId = setTimeout(() => {
          if (this.count === 0) {
            this.view.setNotFound(true);
            this.view.setObjects([]);
            this.view.setTotal(0);
          }
        }, 15000);
        // Walang iloload na pages kapag 0
        if (timeoutId) clearTimeout(timeoutId);
        return;
      }

      // 4) Batch pagination loop (20 per batch by default)
      const pageSize = this.limit || 20;
      let fetched = 0;
      // Kung gusto mong magsimula sa current page, i-offset natin yung fetched.
      // Pero usually, full load tayo mula page 0. If kailangan, uncomment:
      // fetched = Math.max(0, (this.current - 1) * pageSize);

      // Shared buffer + periodic flush (para smooth ang UI)
      let buffer = [];
      const flushBuffer = () => {
        if (!buffer.length) return;
        this.objects = this.objects.concat(buffer);
        this.view.setObjects(this.objects);
        this.view.setTotal(this.objects.length);
        buffer = [];
      };
      const flushInterval = setInterval(flushBuffer, 2000);

      try {
        // compute starting page (kung gusto mong gumamit ng this.current as first page)
        let page = Math.max(0, (this.current || 1) - 1);

        while (fetched < this.count) {
          const skip = page * pageSize;

          const query = {
            limit: pageSize,
            skip,
            where,
            include: ["all"],
            sort: this.sort,
            keys: [
              "store_code",
              "tran_date",
              "tran_id",
              "total",
              "total_taxfree",
              "total_tax",
              "discount_amount",
              "createdAt",
              "cust_name",
              "tran_type",
              "paymenttype",
              "cust_count",
              "status",
              "shareArray",
              "paymenttypetotal",
              "paymenttype2",
              "paymenttype2total",
              "paymenttype3",
              "paymenttype3total",
              "reopen",
              "reopen_user_id",
              "total_pretax",
              "items",
            ],
          };

          // Per-page accumulator via onData
          let pageRowCount = 0;
          const onData = (objects) => {
            if (objects?.length) {
              if (timeoutId) {
                clearTimeout(timeoutId);
                timeoutId = null;
                this.view.setNotFound(false);
              }
              buffer.push(...objects);
              pageRowCount += objects.length;
            }
          };

          // Execute one page (may streaming sa loob; server should honor limit)
          await this.findObjectUseCase.execute(
            this.view.getCollectionName(),
            query,
            { timeout: 100000, onData },
          );

          // flush whatever came for this page
          flushBuffer();

          if (pageRowCount === 0) {
            // no more rows available
            break;
          }

          fetched += pageRowCount;
          page += 1;

          // yield to UI
          await Promise.resolve();
        }
      } finally {
        clearInterval(flushInterval);
        flushBuffer();
      }

      // Safeguard
      if (this.objects.length === 0) {
        this.view.setNotFound(true);
      }
    } catch (error) {
      console.error("Error:", error);
      this.view.showError(error);
    } finally {
      this.hideProgress();
    }
  }

  async findObjects2() {
    try {
      // 1) Load user + store (kailangan para sa storeCodes)
      const user = await getCurrentUserUseCase().execute();
      const storeQuery = {
        include: ["storeAnalytic", "storeAnalytic.expectedRelation"],
        where: { email: user.email },
      };
      this.store2 = await this.findObjectUseCase.execute("users", storeQuery);

      const store =
        this.store2?.[0]?.storeAnalytic?.sort((a, b) =>
          a.name.localeCompare(b.name, undefined, { sensitivity: "base" }),
        ) || [];

      this.view.setStore(store);
    } catch (error) {
      console.error("Error fetching user or store data:", error);
      return;
    }

    // 2) Build filters
    const storeCodes =
      this.store2?.[0]?.storeAnalytic?.map((a) => a?.name).filter(Boolean) ??
      [];

    // Optional safety: require a date filter para hindi mag full-scan
    if (!this.filterDate2 || Object.keys(this.filterDate2).length === 0) {
      console.log("No filterDate2 provided; aborting fetch for safety.");
      return;
    }

    const where = {
      store_code:
        this.filterStore2 === "AllStore"
          ? { $in: storeCodes }
          : this.filterStore2,
      tran_date: this.filterDate2,
    };

    this.showProgress();
    try {
      // 3) Count muna
      this.findObjectUseCase.abort(); // cancel any in-flight
      const { count } = await this.countObjectUseCase.execute(
        this.view.getCollectionName(),
        { where },
      );

      this.count2 = count ?? 0;
      this.view.setCount2(this.count2);

      // Reset UI state
      this.objects2 = [];
      this.view.setObjects2([]);
      this.view.setNotFound2(false);

      // Not-found delay (optional)
      let timeoutId = null;
      if (this.count2 === 0) {
        timeoutId = setTimeout(() => {
          if (this.count2 === 0) {
            this.view.setNotFound2(true);
            this.view.setObjects2([]);
          }
        }, 15000);
        if (timeoutId) clearTimeout(timeoutId);
        return;
      }

      // 4) Batch pagination loop
      const pageSize = this.limit || 50000;
      let fetched = 0;
      let page = Math.max(0, (this.current || 1) - 1); // start page (default 0)

      // Shared buffer + periodic flush for smooth UI
      let buffer = [];
      const flushBuffer = () => {
        if (buffer.length === 0) return;

        // keep this.objects2 as array
        this.objects2 = Array.isArray(this.objects2) ? this.objects2 : [];
        // append to internal
        this.objects2 = this.objects2.concat(buffer);
        // reflect to UI
        this.view.setObjects2(this.objects2);

        buffer = [];
      };
      const flushInterval = setInterval(flushBuffer, 1000);

      try {
        while (fetched < this.count2) {
          const skip = page * pageSize;

          const query = {
            skip,
            limit: pageSize, // <<< 20 per batch
            where,
            include: ["all"],
            sort: this.sort,
            keys: [
              "store_code",
              "status",
              "tran_date",
              "total",
              "total_tax",
              "createdAt",
              "discount_amount",
              "shareArray",
              "paymenttypetotal",
              "paymenttype2",
              "paymenttype2total",
              "paymenttype3",
              "paymenttype3total",
              "reopen",
              "reopen_user_id",
            ],
          };

          // Per-page accumulator
          let pageRowCount = 0;
          const onData = (rows) => {
            if (rows?.length) {
              if (timeoutId) {
                clearTimeout(timeoutId);
                timeoutId = null;
                this.view.setNotFound2(false);
              }
              buffer.push(...rows);
              pageRowCount += rows.length;
            }
          };

          // Fetch one page (server should honor limit)
          await this.findObjectUseCase.execute(
            this.view.getCollectionName(),
            query,
            { timeout: 100000, onData },
          );

          // Push whatever was streamed for this page
          flushBuffer();

          if (pageRowCount === 0) break; // no more rows
          fetched += pageRowCount;
          page += 1;

          // Yield to UI thread
          await Promise.resolve();
        }
      } finally {
        clearInterval(flushInterval);
        flushBuffer();
      }

      // Safeguard
      if (!this.objects2 || this.objects2.length === 0) {
        this.view.setNotFound2(true);
      }
    } catch (error) {
      console.error("Error fetching objects:", error);
      this.view.showError(error);
    } finally {
      this.hideProgress();
      this.progress = false;
    }
  }

  onChangeDate(where) {
    const { tran_date } = where;

    if (tran_date && tran_date.$gte && tran_date.$lte) {
      const startDate = addHours(startOfDay(parseISO(tran_date.$gte)), 5);
      const endDate = addMinutes(
        addHours(addDays(startOfDay(parseISO(tran_date.$lte)), 0), 4),
        59,
      );

      const formattedStartDate = format(startDate, "yyyy-MM-dd HH:mm:ss.SSS");
      const formattedEndDate = format(endDate, "yyyy-MM-dd HH:mm:ss.SSS");

      this.filterDate = {
        tran_date: {
          $gte: formattedStartDate,
          $lte: formattedEndDate,
        },
      };
    }
    this.getObjects();
  }

  onChangeDate2(where) {
    if (where !== "AllMonths" && where) {
      const { $gte, $lte } = where;

      if ($gte && $lte) {
        const startDate = addHours(startOfDay(parseISO($gte)), 5);
        const endDate = addMinutes(
          addHours(addDays(startOfDay(parseISO($lte)), 0), 4),
          59,
        );

        const formattedStartDate = format(startDate, "yyyy-MM-dd HH:mm:ss.SSS");
        const formattedEndDate = format(endDate, "yyyy-MM-dd HH:mm:ss.SSS");

        this.filterDate2 = {
          tran_date: {
            $gte: formattedStartDate,
            $lte: formattedEndDate,
          },
        };
      }
    } else {
      delete this.filterDate2;
    }
    this.getObjects2();
  }

  onChangeStore(where) {
    this.filterStore = where;
    this.getObjects();
  }

  onChangeStore2(where) {
    this.filterStore2 = where;

    // this.getObjects();
    // this.getObjects2();
  }

  calculateSums(objects) {
    const filteredObjects = objects.filter((obj) => obj.status === "C");

    const sumReducer = (acc, object, key) => acc + Number(object[key] || 0);

    const sum_total = filteredObjects.reduce(
      (acc, obj) => sumReducer(acc, obj, "total"),
      0,
    );
    const sum_discount = filteredObjects.reduce(
      (acc, obj) => sumReducer(acc, obj, "discount_amount"),
      0,
    );
    const sum_taxes = filteredObjects.reduce(
      (acc, obj) => sumReducer(acc, obj, "total_tax"),
      0,
    );

    return {
      sum_total,
      sum_discount,
      sum_taxes,
      grossSum: sum_total + sum_discount,
      grossSales: sum_total,
    };
  }

  calculateGrossSalesInfo() {
    const prevGross = 10000;
    const { grossSales } = this.calculateSums(this.objects);

    return {
      value: grossSales,
      percentage: this.calculatePercentage(grossSales, prevGross),
    };
  }

  calculateTotalTransactionInfo() {
    const prevTransaction = 5;
    const totalTransaction = this.objects?.filter(
      (status) => status.status === "C",
    );
    return {
      value: totalTransaction?.length,
      percentage: this.calculatePercentage(
        totalTransaction?.length,
        prevTransaction,
      ),
    };
  }

  calculateTotalGuestInfo() {
    const prevCust = 6;
    const custCount = this.countCustomers();
    return {
      value: custCount,
      percentage: this.calculatePercentage(custCount, prevCust),
    };
  }

  calculateDiscountCost() {
    const prevCust = 6;
    const discountSum = this.objects
      ?.filter((status) => status.status === "C")
      ?.map((cust) => Number(cust.discount_amount))
      .reduce((acc, prev) => acc + prev, 0);
    return {
      value: discountSum,
      percentage: this.calculatePercentage(discountSum, prevCust),
    };
  }

  calculateTotalTaxFree() {
    const object = this.objects;
    const taxFree = object
      ?.filter((status) => status.status === "C")
      ?.map((cust) => Number(cust.total_taxfree))
      .reduce((acc, prev) => acc + prev, 0);
    return {
      value: taxFree,
    };
  }

  calculatePercentage(current, previous) {
    if (previous > 0 && current !== undefined) {
      return parseFloat(((current - previous) / previous) * 100).toFixed(2);
    }
    return 0;
  }

  countCustomers() {
    return this.objects
      ?.filter((status) => status.status === "C")
      ?.filter((cus) => cus.cust_name !== "-")
      .map((cust) => cust.cust_name).length;
  }
}

export default SaleTransPresenter;
